import { Controller } from "@hotwired/stimulus"
import { validateSubscriberCsv } from "@/utils/subscriber_csv_validator"

// 구독자 직접 입력(CSV 텍스트)의 실시간 형식 검증.
// 서버는 파일 업로드와 같은 경로로 처리하므로, 여기서는 잘못된 형식을 미리 잡아
// "업로드했는데 일부가 빠졌다" 는 사후 발견을 없애는 역할만 한다.
export default class extends Controller {
    static targets = ["input", "summary", "issues", "submit"]

    connect() {
        this.validate()
    }

    validate() {
        const text = this.inputTarget.value
        const { errors, warnings, validCount, duplicateCount } = validateSubscriberCsv(text)

        this._renderSummary(text, errors, validCount, duplicateCount)
        this._renderIssues(errors, warnings)

        if (this.hasSubmitTarget) {
            const blocked = errors.length > 0 || validCount === 0
            this.submitTarget.disabled = blocked
            this.submitTarget.classList.toggle("opacity-50", blocked)
            this.submitTarget.classList.toggle("cursor-not-allowed", blocked)
        }
    }

    _renderSummary(text, errors, validCount, duplicateCount) {
        if (!this.hasSummaryTarget) return

        if (text.trim() === "") {
            this.summaryTarget.textContent = "등록할 구독자를 입력해주세요."
            this.summaryTarget.className = "mt-2 text-sm text-slate-600 dark:text-slate-300"
            return
        }

        if (errors.length > 0) {
            this.summaryTarget.textContent = `형식 오류 ${errors.length}건을 고쳐야 등록할 수 있어요.`
            this.summaryTarget.className = "mt-2 text-sm font-medium text-red-700 dark:text-red-300"
            return
        }

        const duplicateNote = duplicateCount > 0 ? ` (중복 ${duplicateCount}건은 한 번만 등록돼요)` : ""
        this.summaryTarget.textContent = `등록 대상 ${validCount}명${duplicateNote}`
        this.summaryTarget.className = "mt-2 text-sm font-medium text-green-700 dark:text-green-500"
    }

    _renderIssues(errors, warnings) {
        if (!this.hasIssuesTarget) return

        const items = [
            ...errors.map((issue) => ({ ...issue, level: "error" })),
            ...warnings.map((issue) => ({ ...issue, level: "warning" })),
        ].slice(0, 20)

        if (items.length === 0) {
            this.issuesTarget.innerHTML = ""
            return
        }

        this.issuesTarget.innerHTML = `
      <ul class="mt-2 space-y-1 text-sm">
        ${items.map((issue) => `
          <li class="${issue.level === "error" ? "text-red-700 dark:text-red-300" : "text-amber-700 dark:text-amber-500"}">
            <span class="font-medium">${issue.line}번째 줄</span> · ${this._escape(issue.message)}
          </li>
        `).join("")}
      </ul>
    `
    }

    _escape(str) {
        const div = document.createElement("div")
        div.textContent = str || ""
        return div.innerHTML
    }
}
